module.exports = __webpack_public_path__ + "img/ember-logo.856bccf8.png";